import { cn } from '@/lib/cn';

export type OrgAvatarSize = 'sm' | 'md' | 'lg';

const SIZE: Record<OrgAvatarSize, string> = {
  sm: 'size-6 text-2xs',
  md: 'size-8 text-xs',
  lg: 'size-12 text-sm',
};

/**
 * An organization: a rounded square with its logo or its initials. People are
 * circles (`PersonAvatar`); organizations are never a circle, so the two read
 * apart at a glance. Squared with `rounded-control`.
 */
export function OrgAvatar({
  name,
  logoUrl,
  size = 'md',
  className,
}: {
  name: string;
  logoUrl?: string | null;
  size?: OrgAvatarSize;
  className?: string;
}) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0]!.toUpperCase())
    .join('');
  return (
    <span
      data-slot="org-avatar"
      role="img"
      aria-label={name}
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-control bg-ink font-semibold text-surface',
        SIZE[size],
        className,
      )}
    >
      {logoUrl ? <img src={logoUrl} alt="" className="size-full object-cover" referrerPolicy="no-referrer" /> : initials || '?'}
    </span>
  );
}
